import Vue from 'vue';
import Router from 'vue-router';
import Menu from './CommonFeature/templates/Menu.vue';
import UketsukeRouter from './Uketsuke/uketsuke-router';
import ItakuRouter from './Hyoutei/Itaku/ItakuRoutes';
import KanriRouter from './Kanri/kanri-router';
import UketsukeCustomRouter from './Uketsuke/custom/uketsuke-custom-routers';
import OrderLogin from './CommonFeature/templates/OrderLogin.vue';
import Logout from './CommonFeature/templates/Logout.vue';
import euc from './CommonFeature/templates/Euc.vue';
import eucUpload from './CommonFeature/templates/EucUpload.vue';
import changeMyPassword from './CommonFeature/templates/ChangeMyPassword.vue';
//20250326 [multipleTabs] sha331 add start
import multipleTabsError from './CommonFeature/templates/MultipleTabsError.vue';
//20250326 [multipleTabs] sha331 add end
//20250618 [ステータス変更対応] morimoto add start
import SystemError from './CommonFeature/templates/SystemError.vue';
//20250618 [ステータス変更対応] morimoto add end
Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/menu',
      name: 'menu',
      component: Menu,
    },
    {
      path: '/login',
      name: 'no_auth/OrderLogin',
      component: OrderLogin,
    },
    {
      path: '/logout',
      name: 'no_auth/logout',
      component: Logout,
    },
    {
      path: '/euc',
      name: 'euc',
      component: euc,
    },
    {
      path: '/eucUpload',
      name: 'eucUpload',
      component: eucUpload,
    },
    {
      path: '/changeMyPassword',
      name: 'no_auth/changeMyPassword',
      component: changeMyPassword,
    },
    //20250326 [multipleTabs] sha331 add start
    {
      path: '/multipleTabsError',
      name: 'no_auth/multipleTabsError',
      component: multipleTabsError,
    },
    //20250326 [multipleTabs] sha331 add end
    //20250618 [ステータス変更対応] morimoto add start
    {
      path: '/SystemError',
      name: 'no_auth/SystemError',
      component: SystemError,
    },
    //20250618 [ステータス変更対応] morimoto add end
    { ...UketsukeRouter },
    { ...ItakuRouter },
    { ...KanriRouter },
    { ...UketsukeCustomRouter },
  ],
});
